import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SimpleBar from "simplebar-react";
import logoSm from "../assets/images/logo-sm.png";
import logoDark from "../assets/images/logo-dark.png";
import logoLight1 from "../assets/images/logo-light.png";
import VerticalLayout from "./VerticalLayouts";
import { Container } from "reactstrap";
import HorizontalLayout from "./HorizontalLayout";

// Dummy profile/logout for illustration
const ProfileMenu = () => (
  <>
    <Link to="/profile" className="nav-link">
      <i className="ri-user-line" style={{marginRight: 6}}></i> Profile
    </Link>
    <Link to="/logout" className="nav-link">
      <i className="ri-logout-box-r-line" style={{marginRight: 6}}></i> Logout
    </Link>
  </>
);

const Sidebar = ({ layoutType }) => {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const verticalOverlay = document.getElementsByClassName("vertical-overlay");
    if (verticalOverlay && verticalOverlay[0]) {
      verticalOverlay[0].addEventListener("click", function () {
        document.body.classList.remove("vertical-sidebar-enable");
        setSidebarOpen(false);
      });
    }
  }, []);

  const addEventListenerOnSmHoverMenu = () => {
    if (
      document.documentElement.getAttribute("data-sidebar-size") === "sm-hover"
    ) {
      document.documentElement.setAttribute(
        "data-sidebar-size",
        "sm-hover-active"
      );
    } else if (
      document.documentElement.getAttribute("data-sidebar-size") === "sm-hover-active"
    ) {
      document.documentElement.setAttribute("data-sidebar-size", "sm-hover");
    } else {
      document.documentElement.setAttribute("data-sidebar-size", "sm-hover");
    }
  };

  // Sidebar toggle for mobile
  const handleSidebarToggle = () => {
    setSidebarOpen((prev) => !prev);
  };

  return (
    <React.Fragment>
      {/* Sidebar Toggle Button for Mobile */}
      <button
        className="sidebar-toggle-btn"
        onClick={handleSidebarToggle}
        aria-label="Toggle sidebar"
        style={{ display: screenWidth <= 991 ? "flex" : "none" }}
      >
        <i className="ri-menu-line"></i>
      </button>

      <div className={`app-menu navbar-menu custom-sidebar-bg${sidebarOpen ? " sidebar-open" : ""}`}
        style={{ left: screenWidth <= 991 ? (sidebarOpen ? 0 : "-250px") : 0 }}
      >
        <div className="navbar-brand-box d-block">
          <Link to="/dashboard" className="logo logo-dark">
            <span className="logo-sm main-logo">
              <img
                src={logoSm}
                alt="logo"
                height="30"
                width="auto"
                className="img-fluid"
              />
            </span>
            <span className="logo-lg d-none d-lg-block">
              <img src={logoDark} alt="logo" height="40" width="auto" className="img-fluid" />
            </span>
          </Link>

          <Link to="/dashboard" className="logo logo-light">
            <span className="logo-sm handle-logo">
              <img
                src={logoSm}
                alt="logo"
                height="30"
                width="auto"
                className="img-fluid"
              />
            </span>
            <span className="logo-lg d-flex align-items-center" style={{ height: "60px" }}>
              <img src={logoLight1} alt="logo" height="40" width="auto" className="img-fluid" />
            </span>
          </Link>

          <button
            onClick={addEventListenerOnSmHoverMenu}
            type="button"
            className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
            id="vertical-hover"
          >
            <i className="ri-record-circle-line"></i>
          </button>
        </div>

        {/* Sidebar Menu */}
        <nav className="sidebar-menu">
          {layoutType === "horizontal" ? (
            <div id="scrollbar" className="h-100">
              <Container fluid>
                <div id="two-column-menu"></div>
                <ul className="navbar-nav" id="navbar-nav">
                  <HorizontalLayout />
                </ul>
              </Container>
            </div>
          ) : layoutType === "twocolumn" ? (
            <React.Fragment></React.Fragment>
          ) : (
            <SimpleBar id="scrollbar" className="h-100">
              <Container fluid>
                <div id="two-column-menu"></div>
                <ul className="navbar-nav" id="navbar-nav">
                  <VerticalLayout layoutType={layoutType} />
                </ul>
              </Container>
            </SimpleBar>
          )}
        </nav>
        {/* Sidebar Bottom: Profile/Logout */}
        <div className="sidebar-bottom">
          <ProfileMenu />
        </div>
        <div className="sidebar-background"></div>
      </div>

      {/* Overlay for mobile */}
      {screenWidth <= 991 && sidebarOpen && (
        <div
          className="vertical-overlay"
          style={{ zIndex: 1039, position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", background: "rgba(0,0,0,0.3)" }}
          onClick={() => setSidebarOpen(false)}
        ></div>
      )}
    </React.Fragment>
  );
};

export default Sidebar;
